module.exports = __webpack_public_path__ + "img/sysyx.cd5beaa3.png";